// react
import { useCallback } from 'react';

// components
import { FormIntroPage } from '@karehero/llama/pwa/pages/FormIntroPage/FormIntroPage';

// hooks
import { useCareProfile } from 'hooks';
import { useGoBack } from 'hooks/useGoBack';
import { CareProfileCategoryID } from '@karehero/models';

// router
import { ROUTES } from 'router';

// store
import { useSelector, dispatch } from 'store';
import { getAccount } from 'store/slices/iamSlice';
import { newToast } from 'store/slices/uiSlice';

/**
 * AttendanceAllowance shows the AttendanceAllowancePage component
 */
export const AttendanceAllowance = () => {
  // hooks
  const goBack = useGoBack();
  const { handleStart, careProfileID } = useCareProfile({
    categoryID: CareProfileCategoryID.AttendanceAllowance,
  });
  const account = useSelector(getAccount);
  const isAdminWithoutCareProfile =
    account?.accountRole?.name === 'KareHero Administrator' && !careProfileID;

  const onStart = useCallback(() => {
    if (isAdminWithoutCareProfile) {
      dispatch(
        newToast({
          title: 'Please select a care circle first',
          variant: 'warning',
          action: {
            label: 'Select care circle',
            href: ROUTES.ADMIN_CARE_CIRCLE_MANAGE,
          },
        }),
      );
      return;
    }
    handleStart();
  }, [isAdminWithoutCareProfile, handleStart]);

  return (
    <FormIntroPage
      onBack={goBack}
      title='Attendance Allowance'
      description='Attendance Allowance is a government benefit for people over 65 who need help with personal care. We handle the paperwork so you can focus on what matters.'
      items={[
        {
          icon: 'file-contract',
          text: 'Complete our in-app form with personal assistance from your care expert.',
        },
        {
          icon: 'print',
          text: "We'll print your information onto the government form, and post it to you for signing.",
        },
        {
          icon: 'envelope',
          text: 'All you need to do is post the form to the government using our free post envelope provided.',
        },
      ]}
      infoText='Your in-app form is prefilled by your care assessment to save you time, and also checked by care experts to help make a successful application.'
      onStart={onStart}
    />
  );
};

export default AttendanceAllowance;
